import { client, gql } from 'data-provider';
import { ITag } from 'interfaces';

interface GetAllTagParams {
  searchString?: string;
  start?: number;
  limit?: number;
}

export const getAllTag = async (queryParam?: GetAllTagParams) => {
  const where = { query: '' };
  if (queryParam?.searchString) {
    where.query = queryParam.searchString;
  }

  const query = gql`
    query ($where: JSON, $sort: SortInput, $start: Int, $limit: Int) {
      tags(where: $where, sort: $sort, start: $start, limit: $limit) {
        data {
          id
          name
          description
        }
        total
        size
        page
      }
    }
  `;

  const variables = {
    where,
    start: queryParam && queryParam.start ? queryParam.start : 1,
    limit: queryParam && queryParam.limit ? queryParam.limit : 10,
  };
  const data = await client.request(query, variables);
  return data.tags as {
    data: ITag[];
    page: number;
    size: number;
    total: number;
  };
};

export const getTag = async (tagId: string) => {
  const query = `
    query($id: ID!) {
      tag(id: $id) {
        id
        name
        description
      }
    }
  `;

  const variables = { id: tagId };
  const data = await client.request(query, variables);
  return data.tag as ITag;
};

export const getAllTagDropdown = async () => {
  const query = gql`
    query TagDropdown {
      tagDropdown {
        id
        name
        description
        keywords
      }
    }
  `;

  const data = await client.request(query);
  return data.tagDropdown as ITag[];
};

export type IImportTagData = Pick<ITag, 'name' | 'description'>;

export const importTag = async (tags: IImportTagData[]) => {
  const mutation = `
    mutation ($input: createInputCSVBulkTagInput) {
      importCSVTag(input: $input) {
        id
      }
    }
  `;

  const variables = {
    input: { data: tags },
  };
  const createdData = await client.request(mutation, variables);
  return createdData;
};
